import { FC } from 'react';
import cn from 'classnames';
import {
    IconStrengths,
    IconWeaknesses,
    IconStrengthsItem,
    IconWeaknessesItem,
} from '@icons';
import InfoBlock from '@components/new/InfoBlock/InfoBlock';
import './StrengthsWeaknesses.scss';

interface StrengthsWeaknessesProps {
    strengths: string[];
    weaknesses: string[];
    valueClassName?: string;
}

const StrengthsWeaknesses: FC<StrengthsWeaknessesProps> = ({ strengths, weaknesses, valueClassName }) => {
    return (
        <div className="StrengthsWeaknesses">
            <InfoBlock className="StrengthsWeaknesses__panel">
                <div className="StrengthsWeaknesses__column">
                    <div className="StrengthsWeaknesses__panel-header">
                        <IconStrengths className="StrengthsWeaknesses__icon" />
                        <span className="StrengthsWeaknesses__panel-title">Strengths</span>
                    </div>
                    <div className="StrengthsWeaknesses__list">
                        {strengths.map((item) => (
                            <div key={item} className={cn("StrengthsWeaknesses__item", valueClassName)}>
                                <IconStrengthsItem className="StrengthsWeaknesses__item-icon" />
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </InfoBlock>
            <InfoBlock className="StrengthsWeaknesses__panel">
                <div className="StrengthsWeaknesses__column">
                    <div className="StrengthsWeaknesses__panel-header">
                        <IconWeaknesses className="StrengthsWeaknesses__icon" />
                        <span className="StrengthsWeaknesses__panel-title">Weaknesses</span>
                    </div>
                    <div className="StrengthsWeaknesses__list">
                        {weaknesses.map((item) => (
                            <div key={item} className={cn("StrengthsWeaknesses__item", valueClassName)}>
                                <IconWeaknessesItem className="StrengthsWeaknesses__item-icon" />
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </InfoBlock>
        </div>
    );
};

export default StrengthsWeaknesses;
